import { render } from "./MarketingMailingDatatableActions.vue?vue&type=template&id=943ad72a"
import script from "./MarketingMailingDatatableActions.vue?vue&type=script&lang=js"
export * from "./MarketingMailingDatatableActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__